import { applyMiddleware, combineReducers, createStore } from 'redux';
import AccountReducer from './AccountReducer';
import AddressToNameReducer from './AddressToNameReducer';
import CoinsMintedEventReducer from './CoinsMintedEventReducer';
import TransactionEventReducer from './TransactionEventReducer';
import richestAccountsMiddleware from './RichestAccountsMiddleware';
import AccountBalanceReducer from './AccountBalanceReducer';
import FrozenAddressesReducer from './FrozenAddressesReducer';
import TransactionsInProgressReducer from './TransactionsInProgressReducer';
import CoinsBoughtEventReducer from './CoinsBoughtEventReducer';
import AddressCanBuyCoinsReducer from './AddressCanBuyCoinsReducer';
import TutorialReducer from './TutorialReducer';

const reducers = combineReducers({
  account: AccountReducer,
  addressToName: AddressToNameReducer,
  coinsMinted: CoinsMintedEventReducer,
  transactions: TransactionEventReducer,
  accountBalances: AccountBalanceReducer,
  addressRefrigerator: FrozenAddressesReducer,
  transactionsInProgress: TransactionsInProgressReducer,
  coinsBought: CoinsBoughtEventReducer,
  addressCanBuyCoinsRefrigerator: AddressCanBuyCoinsReducer,
  tutorialState: TutorialReducer
});

// TODO REMOVE
export default createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(richestAccountsMiddleware)
);


// WEBPACK FOOTER //
// ./src/storage/Storage.js